module.exports = __webpack_public_path__ + "img/hidden.af3e2d73.png";